/* @flow */
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import 'babel-polyfill'
import './semantic/dist/semantic.min.css'
import 'antd/lib/select/style/css'
import 'antd/lib/tooltip/style/css'
import './index.css'

import type { Props } from './App'

setTimeout(() => {
  const roots = document.getElementsByClassName('ac-root')
  Array.from(roots).forEach(root => {
    const props: Props = JSON.parse(root.getAttribute('data-params') || '{}')
    ReactDOM.render(<App { ...props } />, root)
  })
}, 0)




// WEBPACK FOOTER //
// ./src/index.js